import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function Footer() {
  const navigate = useNavigate();
  return (
    <footer className="footer-container" style={{ background: 'var(--color-dark-bg)', padding: '24px 32px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
      <span style={{ fontSize: 12, color: '#666', fontFamily: 'var(--font-body)' }}>
        © 2026 Bhagyashree Dhavalshankh. All rights reserved.
      </span>
      <div style={{ display: 'flex', gap: 20 }}>
        <a href="https://www.instagram.com/framesbybhagya" target="_blank" rel="noopener noreferrer"
          style={{ fontSize: 12, color: 'var(--color-accent)', fontFamily: 'var(--font-body)', letterSpacing: '0.08em', textTransform: 'uppercase', textDecoration: 'none' }}>
          Instagram
        </a>
        <button onClick={() => navigate('/contact')}
          style={{ fontSize: 12, color: 'var(--color-accent)', fontFamily: 'var(--font-body)', letterSpacing: '0.08em', textTransform: 'uppercase', background: 'none', border: 'none', cursor: 'pointer', padding: 0 }}>
          Contact
        </button>
      </div>
    </footer>
  );
}